import Branches from 'app/interface/redux/types/data/generic/branches'

const Default: Branches = {
  data: [],
  loading: true,
  timestamp: +new Date(),
}

export default Default
